// Event name (not numeric id — the id differs across environments) that identifies a panic/SOS event.
export const SOS_EVENT_NAME = 'PANIC_BUTTON'

// Query-param keys for the client "View on map" deep-link.
export const SOS_MAP_QUERY = {
  vehicleId: 'sosVehicleId',
  lat: 'sosLat',
  lng: 'sosLng',
} as const

export interface SosAlert {
  id: number
  driver: string
  vehicle: string
  location: string
  occurrenceTime: string // ISO timestamp the SOS was triggered
  message?: string
  acknowledgeId?: number // id of the acknowledge record; absent => clear locally only
  eventId?: number
  eventLogId?: number
  eventTeam?: string
  vehicleId?: number // target for "View on map"
  lat?: number // resolved from event-log detail
  lng?: number
}
